const NotFound = () => {
  return (
    <section>
      <h1>Error</h1>
      <h2>This page could not be found.</h2>
    </section>
  );
};

export default NotFound;
